export default function initArticle () {

    const article = document.querySelectorAll('.article')

    if (!article.length) return;

    const socialIcons = document.querySelector('.article__info-social');
    const actionButton = document.querySelector('.article__info-action');
    const breadcrumbsHight = document.querySelector('.article__breadcrumbs')?.offsetHeight;
    const bannerHight = document.querySelector('.article__banner').offsetHeight;
    const articleTextLength = document.querySelectorAll('.article')[0].textContent.length;
    let articleTimeRead = document.querySelector('#article__info-timing__time');
    const scrollBar = document.querySelectorAll('.scroll-bar');

    if ( articleTextLength && articleTimeRead ) {
        articleTimeRead.innerHTML = '&nbsp;' + Math.round(articleTextLength / 1000) + '&nbsp;';
    }

    if ( socialIcons && actionButton && breadcrumbsHight && bannerHight ) {
        var elTop = breadcrumbsHight + (bannerHight * 2.5);

        window.addEventListener('scroll', function() {
            if (document.documentElement.scrollTop > elTop){
                socialIcons.style.position = 'fixed';
                socialIcons.style.top = '20vh';
                actionButton.style.position = 'fixed';
                actionButton.style.top = '20vh';
            } else {
                socialIcons.style.position = 'absolute';
                socialIcons.style.top = '0';
                actionButton.style.position = 'absolute';
                actionButton.style.top = '0';
            }
        }, { passive: true });
    }

    if (scrollBar.length) {
        const scrollContainer = document.querySelector('.scroll-bar__target');
        const scrollBarProgress = document.querySelector('.scroll-bar__scroll');

        scrollContainer.parentElement.style.position = 'relative';
        scrollContainer.addEventListener('scroll', function () {
            let scrollLeft = scrollContainer.scrollLeft;
            let scrollWidth = scrollContainer.scrollWidth;
            let percent = scrollLeft / (scrollWidth - scrollContainer.clientWidth) * 67;
            scrollBarProgress.style.left = percent + '%';
        }, { passive: true });
    }

}
